import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const LinkedinIcon = ({
  color = colors.black,
  className,
  onClick,
  size = 16,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      id="linkedin-icon"
    >
      <path
        d="M12 16H4C1.7944 16 0 14.2056 0 12V4C0 1.7944 1.7944 0 4 0H12C14.2056 0 16 1.7944 16 4V12C16 14.2056 14.2056 16 12 16ZM4 1.33333C2.5296 1.33333 1.33333 2.5296 1.33333 4V12C1.33333 13.4704 2.5296 14.6667 4 14.6667H12C13.4704 14.6667 14.6667 13.4704 14.6667 12V4C14.6667 2.5296 13.4704 1.33333 12 1.33333H4Z"
        fill={color}
      />
      <path
        d="M5.33333 6.6064V11.3333C5.33333 11.7015 5.0348 12 4.66667 12C4.29853 12 4 11.7015 4 11.3333V6.6064C4 6.23827 4.29853 5.93974 4.66667 5.93974C5.0348 5.93974 5.33333 6.23827 5.33333 6.6064ZM4.66667 3.73334C4.29853 3.73334 4 4.03187 4 4.4V4.53334C4 4.90147 4.29853 5.2 4.66667 5.2C5.0348 5.2 5.33333 4.90147 5.33333 4.53334V4.4C5.33333 4.03187 5.0348 3.73334 4.66667 3.73334ZM10.2025 6.02907C9.53613 5.89814 8.71347 6.07214 7.9968 6.63627C7.98 6.28307 7.69067 6.00107 7.33333 6.00107C6.9652 6.00107 6.66667 6.2996 6.66667 6.66774V11.3333C6.66667 11.7015 6.9652 12 7.33333 12C7.70147 12 8 11.7015 8 11.3333V8.84627C8.00773 8.83094 8.01747 8.8172 8.02413 8.80094C8.4816 7.682 9.3368 7.2176 9.94547 7.3372C10.4039 7.4272 10.6667 7.84254 10.6667 8.47654V11.3333C10.6667 11.7015 10.9652 12 11.3333 12C11.7015 12 12 11.7015 12 11.3333V8.47667C12 7.2044 11.2944 6.2436 10.2025 6.02907Z"
        fill={color}
      />
    </svg>
  );
};

export default LinkedinIcon;
